import {
	CreatePharmacyCommand,
	PharmacyDto,
	PharmacyType,
	UpdatePharmacyCommand,
} from '@services/src/models';
import moment, { Moment } from 'moment';

export class PharmacyEditDto {
	id?: string;
	name?: string;
	companyName?: string;
	city?: string;
	street?: string;
	voivodeshipId?: number;
	taxNumber?: string;
	placeId?: number;
	type?: PharmacyType;
	//tena
	endDateOfEssityContract?: Moment;
	dateOfJoiningEssityNet?: Moment;
	endContractReasonId?: number;
	nhfContractId?: number;
	essityPaperContractNumber?: string;
	//Actimove
	endDateOfActimoveContract?: Moment;
	dateOfJoiningActimoveNet?: Moment;
	endContractActimoveReasonId?: number;
	actimoveContractId?: number;
	actimovePaperContractNumber?: string;

	healthFundID?: string;
	farmapromPharmacyId?: number;
	kodKom?: number;
	login?: string;
	kam?: string;
	paymentMail?: string;
	contactMail?: string;
	phoneNumber?: string;
	salesRepresentative?: string;
	postalCode?: string;
	district?: number;
	pharmacyChain?: string;
	description?: string;
	iban?: string;
	identifierTena?: number;
	identifierActimove?: number;
	businessContinuity?: string;
	isPharmacyHasNhfContract?: boolean;
	automaticNoteSending?: boolean;
	automaticNoteSendingLastChange?: Moment;
	portalMail?: string;
	secondaryPortalMail?: string;

	constructor(dto: PharmacyDto | undefined) {
		if (!dto) {
			return;
		}

		this.id = dto.id;
		this.name = dto.name;
		this.companyName = dto.companyName;
		this.city = dto.city;
		this.street = dto.street;
		this.voivodeshipId = dto.voivodeshipId;
		this.taxNumber = dto.taxNumber;
		this.placeId = dto.placeId;
		this.endDateOfEssityContract = dto.endDateOfEssityContract
			? moment(dto.endDateOfEssityContract)
			: undefined;
		this.dateOfJoiningEssityNet = dto.dateOfJoiningEssityNet
			? moment(dto.dateOfJoiningEssityNet)
			: undefined;
		this.type = dto.type;
		this.endContractReasonId = dto.endContractReasonId;
		this.nhfContractId = dto.nhfContractId;
		this.essityPaperContractNumber = dto.essityPaperContractNumber;
		this.healthFundID = dto.healthFundID;
		this.farmapromPharmacyId = dto.farmapromPharmacyId;
		this.kodKom = dto.kodKom;
		this.login = dto.login;
		this.kam = dto.kam;
		this.paymentMail = dto.paymentMail;
		this.contactMail = dto.contactMail;
		this.phoneNumber = dto.phoneNumber;
		this.salesRepresentative = dto.salesRepresentative;
		this.postalCode = dto.postalCode;
		this.district = dto.district;
		this.pharmacyChain = dto.pharmacyChain;
		this.description = dto.description;
		this.iban = dto.iban;
		this.identifierTena = dto.identifierTena;
		this.identifierActimove = dto.identifierActimove;
		this.businessContinuity = dto.businessContinuity;
		this.isPharmacyHasNhfContract = dto.isPharmacyHasNhfContract;
		this.automaticNoteSending = dto.automaticNoteSending;
		this.automaticNoteSendingLastChange = dto.automaticNoteSendingLastChange
			? moment(dto.automaticNoteSendingLastChange)
			: undefined;
		this.portalMail = dto.portalMail;
		this.secondaryPortalMail = dto.secondaryPortalMail;

		this.endDateOfActimoveContract = dto.endDateOfActimoveContract
			? moment(dto.endDateOfActimoveContract)
			: undefined;
		this.dateOfJoiningActimoveNet = dto.dateOfJoiningActimoveNet
			? moment(dto.dateOfJoiningActimoveNet)
			: undefined;
		this.endContractActimoveReasonId = dto.endContractActimoveReasonId;
		this.actimoveContractId = dto.actimoveContractId;
		this.actimovePaperContractNumber = dto.actimovePaperContractNumber;
	}

	toCreateCommand(): CreatePharmacyCommand {
		return {
			name: this.name,
			companyName: this.companyName,
			city: this.city,
			street: this.street,
			voivodeshipId: this.voivodeshipId,
			taxNumber: this.taxNumber,
			type: this.type,
			// placeId: this.placeId,
			endDateOfEssityContract:
				this.endDateOfEssityContract?.toDate() || undefined,
			dateOfJoiningEssityNet:
				this.dateOfJoiningEssityNet?.toDate() || undefined,
			endContractReasonId: this.endContractReasonId,
			nhfContractId: this.nhfContractId,
			essityPaperContractNumber: this.essityPaperContractNumber,
			healthFundID: this.healthFundID,
			farmapromPharmacyId: this.farmapromPharmacyId,
			kodKom: this.kodKom,
			login: this.login,
			kam: this.kam,
			paymentMail: this.paymentMail,
			contactMail: this.contactMail,
			phoneNumber: this.phoneNumber,
			salesRepresentative: this.salesRepresentative,
			postalCode: this.postalCode,
			district: this.district,
			pharmacyChain: this.pharmacyChain,
			description: this.description,
			iban: this.iban,
			identifierTena: this.identifierTena,
			identifierActimove: this.identifierActimove,
			businessContinuity: this.businessContinuity,
			automaticNoteSending: this.automaticNoteSending,
			portalMail: this.portalMail,
			secondaryPortalMail: this.secondaryPortalMail,
			endDateOfActimoveContract:
				this.endDateOfActimoveContract?.toDate() || undefined,
			dateOfJoiningActimoveNet:
				this.dateOfJoiningActimoveNet?.toDate() || undefined,
			endContractActimoveReasonId: this.endContractActimoveReasonId,
			actimoveContractId: this.actimoveContractId,
			actimovePaperContractNumber: this.actimovePaperContractNumber,
		};
	}

	toUpdateCommand(): UpdatePharmacyCommand {
		return {
			id: this.id,
			name: this.name,
			companyName: this.companyName,
			city: this.city,
			street: this.street,
			voivodeshipId: this.voivodeshipId,
			taxNumber: this.taxNumber,
			// placeId: this.placeId,
			endDateOfEssityContract:
				this.endDateOfEssityContract?.toDate() || undefined,
			dateOfJoiningEssityNet:
				this.dateOfJoiningEssityNet?.toDate() || undefined,
			type: this.type,
			endContractReasonId: this.endContractReasonId,
			nhfContractId: this.nhfContractId,
			essityPaperContractNumber: this.essityPaperContractNumber,
			healthFundID: this.healthFundID,
			farmapromPharmacyId: this.farmapromPharmacyId,
			kodKom: this.kodKom,
			login: this.login,
			kam: this.kam,
			paymentMail: this.paymentMail,
			contactMail: this.contactMail,
			phoneNumber: this.phoneNumber,
			salesRepresentative: this.salesRepresentative,
			postalCode: this.postalCode,
			district: this.district,
			pharmacyChain: this.pharmacyChain,
			description: this.description,
			iban: this.iban,
			identifierTena: this.identifierTena,
			identifierActimove: this.identifierActimove,
			businessContinuity: this.businessContinuity,
			automaticNoteSending: this.automaticNoteSending,
			portalMail: this.portalMail,
			secondaryPortalMail: this.secondaryPortalMail,
			endDateOfActimoveContract:
				this.endDateOfActimoveContract?.toDate() || undefined,
			dateOfJoiningActimoveNet:
				this.dateOfJoiningActimoveNet?.toDate() || undefined,
			endContractActimoveReasonId: this.endContractActimoveReasonId,
			actimoveContractId: this.actimoveContractId,
			actimovePaperContractNumber: this.actimovePaperContractNumber,
		};
	}
}
